import { render, staticRenderFns } from "./UmbForms.vue?vue&type=template&id=0bbfd970&scoped=true"
import script from "./UmbForms.vue?vue&type=script&lang=ts"
export * from "./UmbForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbfd970",
  null
  
)

export default component.exports